import React from 'react';
import { AlertTriangle, ClipboardCheck, Activity } from 'lucide-react';

const RISK_META = {
  low:      { label: 'Low',      color: '#4ade80' },
  moderate: { label: 'Moderate', color: '#facc15' },
  high:     { label: 'High',     color: '#fb923c' },
  critical: { label: 'Critical', color: '#f87171' },
};

/**
 * ReadinessScores — three SEPARATE indicators.  Never a single fused score.
 *   1. Job Risk               (Low / Moderate / High / Critical)
 *   2. Brief Completeness     (% required-field slots populated)
 *   3. HP Readiness           (% recommended HP tools acknowledged)
 * A single `missing_items` list is passed through so the parent can
 * render "what's still needed" beneath the scores.
 */
export default function ReadinessScores({ readiness }) {
  const {
    job_risk = 'low',
    brief_completeness_pct = 0,
    hp_readiness_pct = 0,
    missing_items = [],
    signals = [],
  } = readiness || {};

  const risk = RISK_META[job_risk] || RISK_META.low;

  return (
    <section className="jbv2-scores" aria-label="Readiness indicators" data-testid="jbv2-readiness">
      <div className="jbv2-score-card jbv2-score--risk" style={{ '--jb-c': risk.color }} data-testid="jbv2-score-risk">
        <span className="jbv2-score-icon"><AlertTriangle size={16} /></span>
        <span className="jbv2-score-label">Job Risk</span>
        <span className="jbv2-score-value">{risk.label}</span>
      </div>

      <div className="jbv2-score-card" style={{ '--jb-c': '#67e8f9' }} data-testid="jbv2-score-completeness">
        <span className="jbv2-score-icon"><ClipboardCheck size={16} /></span>
        <span className="jbv2-score-label">Brief Completeness</span>
        <span className="jbv2-score-value">{brief_completeness_pct}%</span>
        <span className="jbv2-score-bar"><span style={{ width: `${brief_completeness_pct}%` }} /></span>
      </div>

      <div className="jbv2-score-card" style={{ '--jb-c': '#a78bfa' }} data-testid="jbv2-score-hp">
        <span className="jbv2-score-icon"><Activity size={16} /></span>
        <span className="jbv2-score-label">HP Readiness</span>
        <span className="jbv2-score-value">{hp_readiness_pct}%</span>
        <span className="jbv2-score-bar"><span style={{ width: `${hp_readiness_pct}%` }} /></span>
      </div>

      {(missing_items.length > 0 || signals.length > 0) && (
        <details className="jbv2-scores-detail" data-testid="jbv2-readiness-detail">
          <summary>What&rsquo;s influencing these numbers?</summary>
          {missing_items.length > 0 && (
            <div>
              <strong>Missing:</strong>
              <ul>
                {missing_items.slice(0, 8).map((m, i) => <li key={i}>{m}</li>)}
              </ul>
            </div>
          )}
          {signals.length > 0 && (
            <div>
              <strong>Signals applied:</strong>
              <ul>
                {signals.slice(0, 8).map((s, i) => <li key={i}>{s}</li>)}
              </ul>
            </div>
          )}
        </details>
      )}
    </section>
  );
}
